export default __webpack_public_path__ + "static/media/amrah.e79b4e25.png";